import {createSlice} from '@reduxjs/toolkit'
import {
    aboutAvoksinTrailModel,
    mainBannerModel,
    mainEventsModel,
    mindBodyEnvironmentModel,
    partnerAndSponsorsModel,
    raceCategoryModel,
} from "../models/avoskin-trail-run.model";

export const avoskinTrailRunSlice = createSlice({
    name: 'avoskinTrailRun',
    initialState: {
        mainBannerDetail: {...mainBannerModel},
        aboutAvoskinTrailRunDetail: {...aboutAvoksinTrailModel},
        mindBodyEnvironmentDetail: {...mindBodyEnvironmentModel},
        mainEventsDetail: {...mainEventsModel},
        raceCategoryDetail: {...raceCategoryModel},
        partnersAndSponsorsDetail: {...partnerAndSponsorsModel},
        avoskinTrailRunErrorMessage: {}
    },
    reducers: {
        setAvoskinTrailRunMainBannerDetail: (state, action) => {
            state.mainBannerDetail = {...state.mainBannerDetail, ...action.payload}
        },
        setAvoskinTrailRunAboutDetail: (state, action) => {
            state.aboutAvoskinTrailRunDetail = {...state.aboutAvoskinTrailRunDetail, ...action.payload}
        },
        setAvoskinTrailRunMindBodyEnvironmentDetail: (state, action) => {
            state.mindBodyEnvironmentDetail = {...state.mindBodyEnvironmentDetail, ...action.payload}
        },
        setAvoskinTrailRunMainEventsDetail: (state, action) => {
            state.mainEventsDetail = {...state.mainEventsDetail, ...action.payload}
        },
        setAvoskinTrailRunRaceCategoryDetail: (state, action) => {
            state.raceCategoryDetail = {...state.raceCategoryDetail, ...action.payload}
        },
        setAvoskinTrailRunPartnersAndSponsorsDetail: (state, action) => {
            state.partnersAndSponsorsDetail = {...state.partnersAndSponsorsDetail, ...action.payload}
        },
        setAvoskinTrailRunErrorMessage: (state, action) => {
            state.avoskinTrailRunErrorMessage = action.payload
        }
    },
})

export const {
    setAvoskinTrailRunMainBannerDetail,
    setAvoskinTrailRunAboutDetail,
    setAvoskinTrailRunMindBodyEnvironmentDetail,
    setAvoskinTrailRunMainEventsDetail,
    setAvoskinTrailRunRaceCategoryDetail,
    setAvoskinTrailRunPartnersAndSponsorsDetail,
    setAvoskinTrailRunErrorMessage,
} = avoskinTrailRunSlice.actions
const avoskinTrailRunReducer = avoskinTrailRunSlice.reducer

export default avoskinTrailRunReducer
